import { render } from "./Header.vue?vue&type=template&id=2d2e83c0&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=2d2e83c0&lang=less&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2e83c0"]])

export default __exports__